import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/utils/ScrollToTop';
import MainLayout from './components/layout/MainLayout/MainLayout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ToolsPage from './pages/toolsPage';
import NotFoundPage from './pages/NotFoundPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import DigitalReadinessPage from './pages/DigitalReadinessPage';
import JobsToBeDonePage from './pages/JobsToBeDonePage';

function App() {
  useEffect(() => {
    const listener = (event) => {
      if (
        event.data.type === 'hsFormCallback' &&
        event.data.eventName === 'onFormSubmitted'
      ) {
        if (window.fbq) {
          window.fbq('track', 'Lead');
        }
      }
    };

    window.addEventListener('message', listener);
    return () => window.removeEventListener('message', listener);
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<MainLayout pageClass="page--home"><HomePage /></MainLayout>} />
        <Route path="/sobre" element={<MainLayout pageClass="page--about"><AboutPage /></MainLayout>} />
        <Route path="/ferramentas" element={<MainLayout pageClass="page--tools"><ToolsPage /></MainLayout>} />
        <Route path="/ferramentas/maturidade-digital" element={<MainLayout pageClass="page--quiz"><DigitalReadinessPage /></MainLayout>} />
        <Route path="/ferramentas/jobs-to-be-done" element={<MainLayout pageClass="page--jtbd"><JobsToBeDonePage /></MainLayout>} />
        <Route path="/privacy" element={<MainLayout pageClass="page--privacy"><PrivacyPolicyPage /></MainLayout>} />
        <Route path="*" element={<MainLayout pageClass="page--notfound"><NotFoundPage /></MainLayout>} />
      </Routes>
    </Router>
  );
}

export default App;
